const stateTag = "redux state";
export const loadState = () => {
    try {
        const serializedState = window.localStorage.getItem(stateTag);
        if(serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};
export const saveState = state => {
    try {
        const serializedState = JSON.stringify(state);
        window.localStorage.setItem(stateTag, serializedState);
    } catch(error) {
        // ignore errors for now
    };
};


// WEBPACK FOOTER //
// ./src/modules/localStorage.js